<section class="connect-page">
  <div class="connect-card connection-hero">
    <div>
      <span class="connect-pill">Connection</span>
      <h1>{{ creating ? 'New connection' : (connection?.name || connection?.id) }}</h1>
        <p class="connect-muted">Pick a provider from the catalog or use Custom.</p>
      <div class="hero-actions">
          <button color="accent" mat-stroked-button routerLink="/connections">Back</button>
      </div>
    </div>
      @if (connection?.id) {
          <div class="hero-meta">
              <div>
                  <p class="connect-muted">Id</p>
                  <p class="workflow-id">{{ connection?.id }}</p>
              </div>
          </div>
      }
  </div>

  @if (error) {
    <mat-card class="connect-card">
      <mat-card-content class="connect-muted">{{ error }}</mat-card-content>
    </mat-card>
  }

  <mat-card class="connect-card">
    <mat-card-header>
      <p class="connect-section-title">{{ creating ? 'Create connection' : 'Edit connection' }}</p>
    </mat-card-header>
    <mat-card-content>
      <form [formGroup]="form" class="connection-form">
        <mat-form-field appearance="outline">
          <mat-label>Name</mat-label>
          <input matInput formControlName="name" placeholder="HubSpot CRM" />
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Provider</mat-label>
            <mat-select (selectionChange)="onProviderChanged($event.value)" formControlName="providerId">
                <mat-option value="">Custom</mat-option>
            @for (provider of providers; track provider.id) {
                <mat-option [value]="provider.id">{{ provider.name }} ({{ provider.ref }})</mat-option>
            }
          </mat-select>
        </mat-form-field>

          @if (!form.value.providerId) {
              <mat-form-field appearance="outline">
                  <mat-label>Provider ref</mat-label>
                  <input formControlName="ref" matInput placeholder="custom.oauth2"/>
              </mat-form-field>
          }

        <mat-form-field appearance="outline">
          <mat-label>Mode</mat-label>
          <mat-select formControlName="mode">
            <mat-option value="OAuth">OAuth</mat-option>
            <mat-option value="Webhook">Webhook</mat-option>
            <mat-option value="API">API</mat-option>
            <mat-option value="Managed identity">Managed identity</mat-option>
          </mat-select>
        </mat-form-field>
      </form>
    </mat-card-content>
    <mat-card-actions>
      <button mat-flat-button color="primary" (click)="save()" [disabled]="saving || loading">{{ creating ? 'Create' : 'Save' }}</button>
        @if (saving) {
            <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        }
    </mat-card-actions>
  </mat-card>
</section>
